// extracted by mini-css-extract-plugin
export default {"productGallery":"mJ-z","inQuickShop":"nJ-z"};